import React from 'react';
import './VerifycationFailed.scss';  
import logo from "../../../Assets/image (53).png";
import sidelogo from "../../../Assets/image (59).png";
import fail from "../../../Assets/image (60).png";

export default function Login() {
  return (
 

   

     
        <div className="login-container">
          <p>Verification Failed</p>
          <img src={fail} alt="Failed" width={80} />
          <span>You entered the wrong code.</span>
          <button>Login</button>
        </div>
      
   
  );
}
